/**
 * global
 * @author wwl
 * @created 2024/10/10
 * @modified 2024/10/10
 */
import { defineStore } from 'pinia'
import _ from 'lodash'
import { ResponseCode } from '~/utils/constant'
import { fetchUserInfo } from '~~/server/api/user'
import { fetchLinksById } from '~~/server/api/links'

export const useGlobalStore = defineStore('global', {
  state: (): Record<string, any> => ({
    user: {},
    links: null,
    openId: '',
    isWebp: false,
    isLogin: false,
    interfaceResponseTime: '',
    apiErrorMessage: null,
    loginModal: null
  }),
  actions: {
    setUser(data: any) {
      this.user = data
    },
    setLinks(data: any) {
      this.links = data
    },
    setOpenId(data: string) {
      this.openId = data
    },
    setIsWebp(data: boolean) {
      this.isWebp = data
    },
    setInterfaceResponseTime(data: string) {
      this.interfaceResponseTime = data
    },
    setIsLogin(data: boolean) {
      //   console.log('setIsLogin =>', data);
      this.isLogin = data
    },
    setLoginModal(data: any) {
      this.loginModal = data
    },
    setApiErrorMessage(data: any) {
      //   console.log('57-', data, typeof data);
      this.apiErrorMessage = data
    },
    async getUser() {
      const uidCookie = useCookie('uid')
      const userRes = await fetchUserInfo()

      if (userRes?.code === ResponseCode.SUCCESS) {
        uidCookie.value = userRes?.data.id
        this.setUser(userRes?.data)
        this.setOpenId(userRes?.data.openId)
        this.setIsLogin(true)
      }
    },
    async getLinks(action?: Record<string, any>) {
      if (process.server) {
        const id = _.get(action, 'id', 0)
        const linksRes = await fetchLinksById({ id })

        if (linksRes?.code === ResponseCode.SUCCESS) {
          const list = _.get(linksRes, 'data.linkList', [])
          this.setLinks(list)
        }
      }
    }
  }
})
